export {
  RedirectsPage as default,
  getStaticPaths,
  getStaticProps
} from 'features/Redirects'
